import script from "./CalenderCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./CalenderCompo.vue?vue&type=script&setup=true&lang=js"

import "./CalenderCompo.vue?vue&type=style&index=0&id=6fca2284&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fca2284"]])

export default __exports__